import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SnackbarService } from '@bcl/design-system';
import { MenuController } from '@ionic/angular';
import { Subject, takeUntil } from 'rxjs';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { BackButtonService } from 'src/app/services/back-button.service';
import {
  NCList,
  NonconformitiesListPageChanged,
} from 'src/app/shared-components/components/nonconformities-list/nonconformities-api.model';
import { NCsApiService } from 'src/app/shared-components/components/nonconformities-list/nonconformities-api.service';
import { ParentObject } from 'src/app/shared-components/components/notes-list/notes.model';
import { NonconformitiesListComponent } from 'src/app/shared-components/components/nonconformities-list/nonconformities-list.component';

@Component({
  selector: 'app-nc',
  templateUrl: './nc.component.html',
  styleUrls: ['./nc.component.scss'],
})
export class NCComponent implements OnDestroy, OnInit {
  @ViewChild(NonconformitiesListComponent)
  nonconformitiesList: NonconformitiesListComponent;
  public loading = true;
  public backUrl = '';
  public parentObject: ParentObject = 'Users.Users';
  public parentId = 0;
  public ncsList: NCList = { elements: [], totalEntries: 0 };
  public pageSize = 5;
  private destroyed$ = new Subject<void>();

  constructor(
    private api: NCsApiService,
    private snackbarService: SnackbarService,
    private dictionaryService: DictionaryService,
    private menuCtrl: MenuController,
    private router: Router,
    private backButtonService: BackButtonService
  ) {}

  public ngOnInit(): void {
    this.loading = false;
    this.backUrl = this.router.url;
    this.backButtonService.hideBackButton();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  ionViewWillEnter() {
    this.menuCtrl.close();
    this.backButtonService.hideBackButton();
    if (this.nonconformitiesList) {
      this.nonconformitiesList.loadMore.emit({
        pageNumber: 1,
        pageSize: this.pageSize,
        filter: { date: '0' },
      });
    }
  }

  public loadMoreNCs(page: NonconformitiesListPageChanged): void {
    this.getNC(
      page.pageNumber,
      page.pageSize,
      this.parentObject,
      this.parentId
    );
  }

  public getNC(
    pageNumber: number,
    pageSize: number,
    parentObject: ParentObject,
    parentId: number
  ): void {
    this.api
      .getParentNCs({ parentID: parentId, parentObject }, pageNumber, pageSize)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {
          this.ncsList = result;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
        },
      });
  }
}
